import React, { Component } from "react";
import DraggerIcon from "../icons/draggericon";
import CatEditIcon from "../icons/catediticon";
import FpgPlusIcon from "../icons/fpgplusicon";
import TextField from "../component/TextField";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
//Validation import
import SimpleReactValidator from "simple-react-validator";

//Service import
import service from "../services";
import Loader from "../component/loader";
import Tablist from "./Tablist";

let sub;

const screeningTypes = [
  { locationType: "1", label: "In-Person Film" },
  { locationType: "2", label: "Online Film" },
]

class ScreeningTypes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addCatmodal: false,
      imagePreloader: false,
      base64: "",
      getAllCategoryDetails: [],
      getAllCategoryDocs: [],
      name: "",
      changeCategoryTitleName: false,
      id: "",
      loaderFlag: false,
      isDraggable: false,
      eventiveId:'',
      activeTab: "1",
      displayName: "",
      isEdited: false
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
    this.tablistRef = React.createRef();
  }

  AddCategory = () => {
    this.validator.hideMessages("");
    this.setState({
      addCatmodal: true,
      changeCategoryTitleName: false,
      id: "",
      name: "",
      displayName: "",
      eventiveId: "",
      isEdited: true,
    });
  };

  CloseModal = () => {
    this.setState({
      changeCategoryTitleName:false,
      addCatmodal: false,
      id:'',
      name: "",
      displayName: "",
      eventiveId:'',
      isEdited: false
    });
    this.validator.hideMessages();
  };

  componentDidMount = async () => {
    this.getAllCategory();
    this.getcategory();
    this.setState({
      loaderFlag: true,
    });
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
  };

  onInputChange = (e) => {
    this.updateState({
      [e.target.name]: e.target.value,
    });
  };

  updateState = (data, callback) => {
    this.setState({
      ...data,
      isEdited: true
    }, callback);
  }

  getcategory = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "film|screeningType|getList":
          this.setState(
            {
              getAllCategoryDetails: response.data,
              getAllCategoryDocs: response.data.docs,
              error: response.data.error,
            },
            () => {
              this.setState({
                loaderFlag: false,
              });
              if (this.tablistRef.current) this.tablistRef.current.updatedAt();
            }
          );
          break;
        case "film|screeningType|add":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.setState(
              {
                addCatmodal: false,
                loaderFlag: false,
                displayName: "",
                eventiveId: "",
                changeCategoryTitleName: false,
              },
              () => this.apiserve.success("Screening Type created successful.")
            );
          }
          this.getAllCategory(this.state.activeTab);
          break;
        case "film|screeningType|update":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
          this.setState(
            {
              addCatmodal: false,
              changeCategoryTitleName:false,
            },
            this.setState({ loaderFlag: false }),
            this.apiserve.success("Screening Type updated successful.")
          );
          }
          this.getAllCategory(this.state.activeTab);
          break;
        case "film|screeningType|changeOrder":
          break;
      }
    });
  };

  getAllCategory = (type = "1") => {
    this.apiserve.sendevent("film|screeningType|getList", { "locationType": type });
  };

  submitFn = async (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      if (this.state.changeCategoryTitleName) {
        let updateCategory = {
          screeningTypeId: this.state.id,
          eventiveId:this.state.eventiveId,
          name:this.state.displayName,
        };
        this.apiserve.sendevent("film|screeningType|update", updateCategory);
      } else {
        this.apiserve.sendevent("film|screeningType|add", {
          name: this.state.displayName,
          eventiveId: this.state.eventiveId,
          locationType: this.state.activeTab,
          description: "",
        });
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  editCategoryUser = async (item) => {
    this.setState({
      addCatmodal: true,
      changeCategoryTitleName: true,
      name: item.name,
      displayName: item.displayName,
      id: item._id,
      eventiveId:item.eventiveTagId ? item.eventiveTagId : '',
      isEdited: false
    });
    this.validator.hideMessages("")
  };

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const { destination, source } = result;
    const oldIndex = source.index;
    const newIndex = destination.index;
    const arr = [...this.state.getAllCategoryDocs];
    if (newIndex >= arr.length) {
      var k = newIndex - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    const updateArr = [];
    arr.forEach(({ _id }, i) => {
      updateArr.push({
        screeningTypeId: _id,
        sortIndex: i + 1,
      });
    });
    this.setState({ isDraggable: true });
    const data = { order: updateArr };
    this.apiserve.sendevent("film|screeningType|changeOrder", data);
    this.setState({ getAllCategoryDocs: arr });
  };

  validateModel = () => {
    this.setState({
      errorMsg: false,
    });
  };

  handleChangeTab = (tab) => {
    this.setState({ activeTab: tab }, () => {
      this.getAllCategory(tab);
    });
  }
  render() {
    const { getAllCategoryDocs, changeCategoryTitleName } = this.state;
    return (
      <React.Fragment>
          <div className="right_side_wrapper">
          <Tablist active='1' screeningTypes={screeningTypes} handleChangeTab={this.handleChangeTab} name="screeningType" ref={this.tablistRef} />
            <div className="cat_outer_content">
              <div className="category_add_edit category_column">
                <div className="category_header relative d_flex">
                  <p>Film Screening</p>
                  <span className="add_icon d_flex" onClick={this.AddCategory}>
                    <FpgPlusIcon
                      width="16"
                      height="16"
                      color="#ffffff"
                      stroke="#4F4F4F"
                    />
                  </span>
                </div>
                <div className="list_wrap striped_droppable_table">
                  <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="droppable">
                      {(provided, snapshot) => (
                        <ul
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                        >
                          {getAllCategoryDocs.map((item, index) => (
                            <Draggable
                              key={item._id}
                              draggableId={item._id}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <li
                                  className="pointer d_flex d_flex_align_center"
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <span className="cat_drag d_flex">
                                    <DraggerIcon />
                                  </span>
                                  <div className="cat_name d_flex">
                                    <p className="">{item.displayName}</p>
                                  </div>
                                  <div className="action d_flex d_flex_align_center">
                                    <span
                                      className="cat_edit pointer"
                                      onClick={() =>
                                        this.editCategoryUser(item)
                                      }
                                    >
                                      <CatEditIcon />
                                    </span>
                                  </div>
                                </li>
                              )}
                            </Draggable>
                          ))}
                        </ul>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            </div>
            <div
              className={`user_popup ${this.state.addCatmodal ? "active" : ""}`}
            >
              <span className="popup_overlay" onClick={this.CloseModal}></span>
              <div className="cat_modal_inner">
                <p className="cat_title text_center">
                  {changeCategoryTitleName
                    ? "Edit Screening Type"
                    : "Screening Type"}
                </p>
                <form>
                  <div className="field_row horizontal_field d_flex">
                    <TextField
                      type="text"
                      label="Screening Name"
                      name="displayName"
                      value={this.state.displayName}
                      onChange={this.onInputChange}
                      fpgerror={this.validator.message(
                        "Screening Name",
                        this.state.displayName,
                        "required"
                      )}
                    />
                  </div>
                  { 
                  <div className="field_row horizontal_field d_flex">
                    <TextField
                      type="text"
                      label="Eventive ID"
                      name="eventiveId"
                      value={this.state.eventiveId}
                      onChange={this.onInputChange}
                      fpgerror={this.validator.message(
                        "Eventive ID",
                        this.state.eventiveId,
                        "required"
                      )}
                    />
                  </div>}
                  <div className="cat_btns text_center">
                    <button type="button" onClick={this.CloseModal}>
                      CANCEL
                    </button>
                    <button
                      className={this.state.changeCategoryTitleName && !this.state.isEdited ? "disabled" : "active"}
                      disabled={this.state.changeCategoryTitleName && !this.state.isEdited}
                      onClick={(e) => this.submitFn(e)}
                    >
                      SAVE
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button
                  className="small_btn active"
                  onClick={this.validateModel}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}

export default ScreeningTypes;
